<template>
  <div class="warp"> 
    <div class="title">CAC2025参展商邀请函申请</div>
    <div class="item">
      <div class="smallTitle">一、邀请函办理时间</div>
      <div class="text">11月30日 - 3月1日（1月28日-2月4日春节假期）</div>
    </div>
    <div class="item">
      <div class="smallTitle">二、邀请停留时间（不可更改）：</div>
      <div class="text">限CAC2025农化展会期间，即2025年3月14-20日。</div>
    </div>   
    <div class="item">
      <div class="smallTitle">三、参展商提交材料</div>
      <div class="text">1.申请人签证邀请函模版（填写附件1-word模板并回传）</div>
      <div class="text">2.申请人信息表（填写附件2-excel模板并回传）</div>
      <div class="text">3.申请人护照首页扫描件（离展期结束不少于6个月，即有效期2025年9月19日以后）</div>
      <div class="text">4.企业派遣函</div>
    </div>
    <div class="item">
      <div class="text">截至2024年11月22日-2025年12月31日，中国已同25个国家实现全面免签，对38个国家实行单方面免签,此外，同157个国家和地区缔结了涵盖不同护照种类的互免签证协定。来华外国人还可利用过境免签、邮轮免签及赴海南岛等特定区域免签政策来华旅游或开展商务活动。</div>
      <div class="smallTitle">免签政策受惠国家清单：</div>
      <table>
        <tbody>
          <tr>
            <td class="tabTitle">互免签证国家：</td>
            <td class="text">阿尔巴尼亚、阿联酋、安提瓜和巴布达、巴巴多斯、巴哈马、白俄罗斯、波黑、多米尼克、厄瓜多尔、斐济、格林纳达、格鲁吉亚、哈萨克斯坦、卡塔尔、马尔代夫、毛里求斯、塞尔维亚、塞舌尔、圣马力诺、苏里南、所罗门群岛、泰国、汤加、新加坡、亚美尼亚</td>
          </tr>
          <tr>
            <td class="tabTitle">免签入境不超过30天的国家：</td>
            <td class="text">爱尔兰、爱沙尼亚、安道尔、奥地利、澳大利亚、保加利亚、北马其顿、比利时、冰岛、波兰、丹麦、德国、法国、芬兰、韩国、荷兰、黑山、克罗地亚、拉脱维亚、列支敦士登、卢森堡、罗马尼亚、马耳他、马来西亚、摩纳哥、挪威、葡萄牙、日本、瑞士、塞浦路斯、斯洛伐克、斯洛文尼亚、新西兰、文莱、西班牙、希腊、匈牙利、意大利</td>
          </tr>
        </tbody>
      </table>
      <div class="text">具体国家签证政策请查询当地各驻华大使馆或签证处。以上信息为网络收集，数据仅供参考。</div>
    </div>
    <!-- <div class="textInter">特别提示: 从今年12月1日起到明年11月30日，法国、德国、意大利、荷兰、西班牙和马来西亚的公民来华进行短期入境或过境，可享受免签待遇，停留时间不超过15天。</div> -->
    <!-- <div class="time">2023年11月</div> -->
    <div style="margin-top:10px">
      <el-button type="primary"  ><a :href="file1" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">附件1：申请人签证邀请函模板.docx</a></el-button>
      <el-button type="primary"  ><a :href="file2" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">附件2：申请人信息表.xls</a></el-button>
      <el-button type="primary"  ><a :href="file3" style="font-size:14px;color:#fff;text-decoration:none;" target="_blank" download="">附件3：企业派遣函.xls</a></el-button>
    </div>
  </div>
</template>
<script>


export default {
  data(){
      return{
        file1:'./附件1：申请人签证邀请函模板.docx',
        file2:'./附件2：申请人信息表.xls',
        file3:'./附件3：企业派遣函.doc'
      }
  },
  components: {},
  mounted() {
   
  },
  methods: {
  


  }
}
</script>
<style lang="less">

.warp{
  max-width: 80%;
  padding-left: 5% !important;
}
.title{
  font-size: 28px;
  text-align: center;
  padding:30px 0;
  font-weight: bold;
}
.item{
  padding-bottom: 14px;
  table, th, td {
    border: 1px solid black;
    border-collapse: collapse; /* 移除单元格之间的间隔 */
  }
  td {
    padding: 10px 6px;
  }
  .tabTitle{
    font-weight: bold;
    width: 11%;
    text-align: center;
  }
}
.item .smallTitle{
  font-weight: bold;
  padding:6px 0;
  font-size: 18px;
}
.item .text{
  font-size: 16px;
  line-height: 28px;
}
.textInter{
  font-size: 16px;
  line-height: 28px;
}
.time{
  font-size: 16px;
  text-align: right;
  padding-top: 10px;
}
</style>

